// extracted by mini-css-extract-plugin
export var header = "_u8-1";
export var maskBottom = "_u8-6";
export var maskMiddle = "_u8-7";
export var maskTop = "_u8-5";
export var root = "_u8-0";
export var scrollDownButton = "_u8-3";
export var scrollDownButtonHidden = "_u8-4";
export var viewport = "_u8-2";